<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: 'App'
    }
</script>

<style>
    #app {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        padding-top: 30px !important;
        padding-left: 40px;
        padding-right: 40px;
    }

    html, body {
        max-height: 639px;
    }

    @media only screen and (min-width: 900px) {
        #app {
            margin-left: auto;
            margin-right: auto;
            width: 800px;
            padding: 0;
        }
    }
    @media only screen and (max-width: 400px) {
        #app {
            padding-left: 24px;
            padding-right: 24px;
        }
    }
</style>

<style lang="css">
    @import '../src/assets/styles/local.css';
    @import '../src/assets/styles/fonts.css';

    h3, h4, h2 {
        overflow-wrap: break-word;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue